/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as MethodologyRouteImport } from './routes/methodology'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SubscriptionSuccessRouteImport } from './routes/subscription.success'
import { Route as SubscriptionCancelRouteImport } from './routes/subscription.cancel'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedSubscriptionRouteImport } from './routes/_authenticated/subscription'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'

const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const MethodologyRoute = MethodologyRouteImport.update({
  id: '/methodology',
  path: '/methodology',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionSuccessRoute = SubscriptionSuccessRouteImport.update({
  id: '/subscription/success',
  path: '/subscription/success',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionCancelRoute = SubscriptionCancelRouteImport.update({
  id: '/subscription/cancel',
  path: '/subscription/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSubscriptionRoute =
  AuthenticatedSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/methodology': typeof MethodologyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/home': typeof AuthenticatedHomeRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/subscription': typeof AuthenticatedSubscriptionRoute
  '/support': typeof AuthenticatedSupportRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/subscription/cancel': typeof SubscriptionCancelRoute
  '/subscription/success': typeof SubscriptionSuccessRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/methodology': typeof MethodologyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/home': typeof AuthenticatedHomeRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/subscription': typeof AuthenticatedSubscriptionRoute
  '/support': typeof AuthenticatedSupportRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/subscription/cancel': typeof SubscriptionCancelRoute
  '/subscription/success': typeof SubscriptionSuccessRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/methodology': typeof MethodologyRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/subscription': typeof AuthenticatedSubscriptionRoute
  '/_authenticated/support': typeof AuthenticatedSupportRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/subscription/cancel': typeof SubscriptionCancelRoute
  '/subscription/success': typeof SubscriptionSuccessRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/methodology'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/home'
    | '/profile'
    | '/subscription'
    | '/support'
    | '/login'
    | '/subscription/cancel'
    | '/subscription/success'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/methodology'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/home'
    | '/profile'
    | '/subscription'
    | '/support'
    | '/login'
    | '/subscription/cancel'
    | '/subscription/success'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/methodology'
    | '/privacy-policy'
    | '/terms-of-service'
    | '/_authenticated/home'
    | '/_authenticated/profile'
    | '/_authenticated/subscription'
    | '/_authenticated/support'
    | '/_unauthenticated/login'
    | '/subscription/cancel'
    | '/subscription/success'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  MethodologyRoute: typeof MethodologyRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  SubscriptionCancelRoute: typeof SubscriptionCancelRoute
  SubscriptionSuccessRoute: typeof SubscriptionSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/methodology': {
      id: '/methodology'
      path: '/methodology'
      fullPath: '/methodology'
      preLoaderRoute: typeof MethodologyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription/success': {
      id: '/subscription/success'
      path: '/subscription/success'
      fullPath: '/subscription/success'
      preLoaderRoute: typeof SubscriptionSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription/cancel': {
      id: '/subscription/cancel'
      path: '/subscription/cancel'
      fullPath: '/subscription/cancel'
      preLoaderRoute: typeof SubscriptionCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/support': {
      id: '/_authenticated/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscription': {
      id: '/_authenticated/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AuthenticatedSubscriptionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSubscriptionRoute: typeof AuthenticatedSubscriptionRoute
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSubscriptionRoute: AuthenticatedSubscriptionRoute,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  MethodologyRoute: MethodologyRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  SubscriptionCancelRoute: SubscriptionCancelRoute,
  SubscriptionSuccessRoute: SubscriptionSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
